// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"26":"723b30c7d7b0f798","840":"69d4bfb4ec47f269"}[chunkId] + ".js";
};